@if (ready) {
  <div
    class="clp-wrapper"
    [ngClass]="{ 'pano-clp': panoId && panoId.length > 0 }"
    >
    <div id="clp" [class]="accentColor" class="responsive-page-container-lg">
      <div class="clp-header"
        [style.visibility]="tabNavStuck ? 'hidden' : 'visible'">
        @if (!(panoId && panoId.length > 0)) {
          <div class="clp-info" [style.paddingBottom]="tabNavHeight">
            @switch (name) {
              @case ('efields') {
                <img
                  id="efields-logo"
                  src="assets/img/efields 1-01.png"
                  alt="efields: connecting science to fields"
                  />
              }
              @case ('ebarns') {
                <img
                  id="ebarns-logo"
                  src="assets/img/ebarns-logo.png"
                  alt="ebarns: connecting science to farmers"
                  />
              }
              @default {
                <img [src]="icon" alt="{{ title }} icon" />
                <h1 [innerHTML]="title"></h1>
              }
            }
            <div aria-hidden class="separator"></div>
            <div [innerHTML]="description"></div>
          </div>
          <div
            class="clp-img"
            [style.visibility]="tabNavStuck ? 'hidden' : 'visible'"
            >
            <img [src]="headerImage" [alt]="title" />
          </div>
        } @else {
          <div class="pano-header" [ngClass]="{ 'pano-opened': panoOpened }">
            <div
              class="pano-img"
              [style.visibility]="tabNavStuck ? 'hidden' : 'visible'"
              [style.--featured-image]="panoImg | async"
              (click)="openPano()"
              >
              <div class="animate"></div>
              <!-- <img [src]="pano.entranceImageURL" [alt]="title" /> -->
              <div class="pano-img-overlay">
                <div class="text">
                  <h2>Start the tour</h2>
                  <div class="icon">
                    <svg
                      height="32px"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 128 128"
                      >
                      <path
                        d="M64,0a64,64,0,1,0,64,64A64,64,0,0,0,64,0Zm0,115.2A51.2,51.2,0,1,1,115.2,64,51.26,51.26,0,0,1,64,115.2Z"
                        />
                      <polygon
                        points="49.36 38.4 49.36 64 49.36 89.6 71.53 76.8 93.7 64 71.53 51.2 49.36 38.4"
                        />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div class="pano-wrapper" #pano>
              <app-panorama
                [id]="panoId"
                [embedded]="true"
                (fullscreenButtonClick)="openPano()"
              ></app-panorama>
            </div>
            <h1 [innerHTML]="title"></h1>
          </div>
        }
      </div>
      <div
        class="tab-nav"
        #tabNav
        [style.marginTop]="'-' + tabNavHeight"
        [class.stuck]="tabNavStuck"
        >
        @if (icon && icon.length > 0) {
          <img
            [src]="icon"
            alt="{{ title }} icon"
            />
        }
        <div class="tabs">
          @for (tab of tabs; track tab; let i = $index) {
            @if (
              tab.label != 'Interact' || title != 'eFields') {
              <a
                (click)="onTabClick(i)"
                (dblclick)="onTabDblClick(i)"
                (keyup.enter)="onTabClick(i)"
                [ngClass]="{ active: currentTabIndex == i }"
                target="_blank"
              [attr.href]="
                tab.link_override.length > 0 ? tab.link_override : undefined
              "
                tabindex="0"
              [matTooltip]="
                tab.double_click_link
                  ? tab.double_click_link.tooltip
                  : undefined
              "
                [matTooltipShowDelay]="2000"
                >
                {{ tab.label }}
                @if (tabs[i].link_override.length > 0) {
                  <span
                    class="material-icons"
                    >
                    open_in_new
                  </span>
                }
              </a>
            } @else {
              <a
                (click)="efieldsInteractiveTabClick(tab.link_override)"
                (keyup.enter)="efieldsInteractiveTabClick(tab.link_override)"
                tabindex="0"
                >
                {{ tab.label }}
                @if (tabs[i].link_override.length > 0) {
                  <span
                    class="material-icons"
                    >
                    open_in_new
                  </span>
                }
              </a>
            }
          }
        </div>
      </div>
      @if (currentTab?.banner_title.length > 0 || currentTab?.banner_text) {
        <div
          class="clp-banner"
          >
          <div class="content">
            @if (currentTab?.banner_title.length > 0) {
              <h2
                [innerHTML]="currentTab?.banner_title"
              ></h2>
            }
            <div
              [innerHTML]="currentTab?.banner_text"
              class="clp-banner-text"
            ></div>
            @for (button of currentTab?.banner_buttons; track button) {
              <a
                mat-raised-button
                [href]="button.url"
                [innerHTML]="button.name"
                class="banner-btn"
                target="_blank"
                >
              </a>
            }
          </div>
        </div>
      }
      @if (currentTab?.sectionObjs) {
        <div class="clp-body">
          @for (t of currentTab?.sectionObjs; track t) {
            <app-custom-page-section
              [sectionData]="t"
            ></app-custom-page-section>
          }
        </div>
      }
      @if (currentTab?.footer_title || currentTab?.footer_text) {
        <div
          class="clp-footer"
          >
          <div class="content">
            @if (currentTab?.footer_title.length > 0) {
              <h2
                [innerHTML]="currentTab?.footer_title"
              ></h2>
            }
            <div
              [innerHTML]="currentTab?.footer_text"
              class="clp-footer-text"
            ></div>
          </div>
        </div>
      }
    </div>
  </div>
} @else {
  <div class="page-loading-center">
    <app-loading-indicator></app-loading-indicator>
  </div>
}
